memoizedSnapshot